/**
 * In-memory Return & Cancel Request list snapshot so Back from details
 * restores the exact previous table/filters without refetching APIs.
 */

const EXPECT_RETURN_KEY = 'return_cancel_expect_list_return';

let listSnapshot = null;
/** Frozen copy taken when opening details — survives React Strict Mode remount. */
let frozenSnapshotForReturn = null;
let clearFrozenTimer = null;

export const setReturnCancelListSnapshot = (snapshot) => {
  listSnapshot = snapshot;
};

export const getReturnCancelListSnapshot = () => listSnapshot;

export const clearReturnCancelListSnapshot = () => {
  listSnapshot = null;
};

export const markReturnCancelExpectReturn = () => {
  try {
    sessionStorage.setItem(EXPECT_RETURN_KEY, '1');
  } catch (error) {
    console.error('Failed to mark Return/Cancel return:', error);
  }
  frozenSnapshotForReturn = listSnapshot;
  if (clearFrozenTimer) {
    clearTimeout(clearFrozenTimer);
    clearFrozenTimer = null;
  }
};

/**
 * Returns frozen list snapshot when returning from request details.
 * Safe under React Strict Mode (double-mount): snapshot stays available briefly.
 */
export const takeReturnCancelListSnapshotIfReturning = () => {
  try {
    const flagged = sessionStorage.getItem(EXPECT_RETURN_KEY) === '1';
    if (frozenSnapshotForReturn) return frozenSnapshotForReturn;
    if (flagged) return listSnapshot;
    return null;
  } catch (error) {
    return frozenSnapshotForReturn || null;
  }
};

/** Call after applying restore. Clears expect flag; keeps frozen briefly for Strict remount. */
export const acknowledgeReturnCancelListRestore = () => {
  try {
    sessionStorage.removeItem(EXPECT_RETURN_KEY);
  } catch (error) {
    // ignore
  }
  if (clearFrozenTimer) clearTimeout(clearFrozenTimer);
  clearFrozenTimer = setTimeout(() => {
    frozenSnapshotForReturn = null;
    clearFrozenTimer = null;
  }, 1000);
};
